module.exports = __webpack_public_path__ + "static/media/logo.bd83c167.jpg";